export const VALUES = {
  labelsPageSize: 100,
  labelsMaxPreloadCount: 1000,
  milestonesPageSize: 100,
  milestonesMaxPreloadCount: 1000,
  organizationsMaxPreloadCount: 1000,
  organizationsPageSize: 100,
  issueTypesPageSize: 10,
  issueTypesMaxPreloadCount: 10,
}
